import { ItemDef } from '../config/item-defs';
import { ECONOMY } from '../config/economy-tuning';

/**
 * Client-side mirror of backend/src/game/economy/sim/pricing.ts — display
 * estimates for the vendor UI only. The server (economy.service.ts) is the
 * authoritative source for every real price; these exist purely so the
 * player sees a cost before committing to a request.
 */

export function sellPrice(itemDef: Pick<ItemDef, 'baseValue'>): number {
  return Math.round(itemDef.baseValue * ECONOMY.SELL_PRICE_FRACTION);
}

/**
 * `buyPrice` was removed on 2026-09-04 along with the Shop's Curios buy shelf.
 * See backend/src/game/economy/sim/pricing.ts for the full reasoning; the
 * short version is that a curio has one verb, Sell, so a shelf selling them
 * back at a markup was a 3x-to-15x loss on an object that does nothing while
 * you hold it. Curios now have a second use that is not a purchase:
 * design/gdd/commissions.md.
 */

export function expandStashCost(currentCapacity: number): number {
  return ECONOMY.BASE_EXPAND_COST + (currentCapacity - ECONOMY.INITIAL_STASH_CAPACITY) * ECONOMY.COST_PER_SLOT_INCREMENT;
}

export function waxFromEmberExchange(emberAmount: number): number {
  return Math.round(emberAmount * ECONOMY.EXCHANGE_RATE);
}
